import { okposItemList, shopItemList } from "../lib/ec2-api-lib";
import { posList } from "./posList";

export function getItemList({ shopInfo }) {
  if (!posList.includes(shopInfo.posName)) return { err: { message: "INVALID POSNAME" } };
  const params = { shopId: shopInfo.shopId }
  if (shopInfo.posName === "OKPOS") return okposItemList(params)
  else return shopItemList(params)
}